import React, { useState, useEffect } from "react";
import Button from "../components/buttons/Button";
import Text from "../components/typography/Text";
import { useAuth } from "../contexts/auth";
import fetchApi from "../fetchApi";

const SUCCESS_MESSAGE_DURATION = 3000;

const Newsletter = () => {
  const { user, fetchUser } = useAuth();
  const [subscribed, setSubscribed] = useState(false);
  const { newsletter_optin = false, newsletter = false } = user || {};

  useEffect(() => {
    if (subscribed) setTimeout(fetchUser, SUCCESS_MESSAGE_DURATION);
  }, [subscribed]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!user || newsletter_optin || newsletter) return null;

  const disableOptIn = async () => {
    try {
      const formData = new FormData();
      formData.append("newsletter_optin", "1");
      await updateUser(user, formData);
      setSubscribed(true);
    } catch (error) {
      console.error(error);
    }
  };

  const subscribe = async () => {
    try {
      const formData = new FormData();
      formData.append("newsletter_optin", "1");
      formData.append("newsletter", "1");
      await updateUser(user, formData);
      setSubscribed(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="oNewsletter">
      <div className="oNewsletter_wrapper -contained">
        <div className="oNewsletter_text">
          <Text black>
            Subscribe to our newsletter to get news about the latest job
            offerings and events!
          </Text>
        </div>
        {!subscribed && (
          <div className="oNewsletter_actions">
            <Button text onClick={disableOptIn}>
              I'm not interested
            </Button>
            <Button rounded outlined orange onClick={subscribe}>
              Subscribe
            </Button>
          </div>
        )}
        {subscribed && (
          <div className="oNewsletter_thanks">
            <Text black>Thank you !</Text>
          </div>
        )}
      </div>
    </div>
  );
};

const updateUser = (user, formData) =>
  fetchApi(
    `/users/${user.id}?slug=${user.slug}`,
    {
      method: "post",
      body: formData,
    },
    false
  );

export default Newsletter;
